import loadOrdersList from "@NA/Handlers/ADILoadOrdersListHandler";
import loadOrders from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrders";
import ordersListParameter from "@NA/Handlers/ADIOrdersListParameterHandler";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getAccountsDataView } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import loadAccounts from "@insite/client-framework/Store/Data/Accounts/Handlers/LoadAccounts";
import { getBillToState, getBillTosDataView } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadBillTos from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTos";
import clearSearch from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/ClearSearch";
import updateSearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { OrderHistoryPageContext } from "@insite/content-library/Pages/OrderHistoryPage";
import Accordion from "@insite/mobius/Accordion";
import AccordionSection, { AccordionSectionHeader, AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import Button, { ButtonPresentationProps, ButtonProps } from "@insite/mobius/Button";
import DatePicker, { DatePickerPresentationProps, DatePickerState } from "@insite/mobius/DatePicker";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import { IconWrapper } from "@insite/mobius/Icon";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import Search from "@insite/mobius/Icons/Search";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import TextField, { TextFieldPresentationProps, TextFieldProps } from "@insite/mobius/TextField";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import React, { useCallback, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import DropDown from "@NA/Icons/DropDown";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";

const mapStateToProps = (state: CustomApplicationState) => {
    const billToId = state.context.session.billToId;
    const customerNumber = getBillToState(state, billToId).value?.customerNumber ?? "";
    return {
        customerNumber,
        filtersOpen: state.pages.orderHistory.filtersOpen,
        billTosDataView: getBillTosDataView(state, {}),
        accountsDataView: getAccountsDataView(state),
        ordersDataView: state.ADIGlobalData.ordersListStore.ordersList,
        getOrdersParameter: state.ADIGlobalData.ordersListStore.parameter,
        isAuthenticated: state.context.session.isAuthenticated,
        location: getLocation(state),
        isLoading: state.ADIGlobalData.ordersListStore.isLoading
    };
};

const mapDispatchToProps = {
    loadBillTos,
    loadAccounts,
    updateSearchFields,
    loadOrdersList,
    loadOrders,
    clearSearch,
    ordersListParameter,
};

type Props = WidgetProps & HasHistory & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface OrderFilterStyles {
    container?: GridContainerProps;
    filtersContainer?: InjectableCss;
    neworderButton?: ButtonPresentationProps;
    heading?: TypographyProps;
    headingItem?: GridItemProps;
    fromGridItem?: GridItemProps;
    toGridItem?: GridItemProps;
    datePickerToDateStyles?: DatePickerPresentationProps;
    datePickerFromDateStyles?: DatePickerPresentationProps;
    orderNumberText?: TextFieldProps;
    buttonsItem?: GridItemProps;
    searchBtn?: ButtonProps;
    clearBtn?: ButtonProps;
    icon?: TypographyProps;
    gridItem?: GridItemProps;
    dropdownContainer?: InjectableCss;
    dropdownValue?: InjectableCss;
    dropdownList?: InjectableCss;
    dropdownValues?: InjectableCss;
    dropdownLabel?: InjectableCss;
    input?: TextFieldPresentationProps;
    mobilePoNumberGrid?: GridItemProps;
    Accordion?: InjectableCss;
    mtGridItem?: GridItemProps;
    mtGridItemDate?: GridItemProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    footerBtnWrapper?: InjectableCss;
    searchSectionWrapper?: InjectableCss;
    toFromWrapper?: InjectableCss;
    dateWrapper?: InjectableCss;
    SearchTextFieldText?: InjectableCss;
}

export const ordersFilterStyles: OrderFilterStyles = {
    container: {
        css: css`
            padding-bottom: 15px;
        `,
    },
    filtersContainer: {
        css: css`
            background-color: ${ADIColors.white};
            padding: 0px 15px;
        `,
    },
    SearchTextFieldText: {
        css: css`
        border-radius:0px !important;
        border: 1px solid #cfcfcf !important;
        margin-top:-15px!important;
        `,
    },
    headingItem: {
        width: 12,
        css: css`
            padding-bottom: 5;
            border-bottom: 1px solid ${ADIColors.gray2};
        `,
    },
    heading: {
        variant: "h5",
        as: "h2",
        css: css`
            margin: 0;
            font-weight: bold;
            font-size: 24px;
            color: ${ADIColors.darkBlue1};
        `,
    },

    neworderButton: {
        css: css`
            width: 100%;
            height: 40px;
            padding: 0 10px;
            margin-top: 0;
            border-radius: 4px;
            background-color: ${ADIColors.blue5};
            box-shadow: none;
            margin-bottom: 0;
            font-family: "Nunito Sans", sans-serif;
            font-size: 16px;
            font-weight: bold;
            line-height: normal;
        `,
    },
    fromGridItem: { width: [6, 6, 3, 2, 2] },
    toGridItem: { width: [6, 6, 3, 2, 2] },
    datePickerFromDateStyles: {
        cssOverrides: {
            datePicker: css`
                .react-calendar {
                    left: 0px
                }
             ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`
                       .react-calendar {
                            left: 0px
                        }
                    `,
                        null,
                        null,
                    ])}
            `,

        },
        calendarIconProps: {
            css: css`
            display:none;
                svg {
                    transform: translate(10px, -7px);
                }
            `,
            color: "primary",
        },
    },
    datePickerToDateStyles: {
        cssOverrides: {
            datePicker: css`
                .react-calendar {
                    left: -205px
                }
             ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`
                       .react-calendar {
                            left: 0px
                        }
                    `,
                        null,
                        null,
                    ])}
            `,

        },
        calendarIconProps: {
            css: css`
            display:none;
                svg {
                    transform: translate(10px, -7px);
                }
            `,
            color: "primary",
        },
    },

    buttonsItem: {
        css: css`
            flex-direction: column;
            flex-basis: 13%;
            max-width: 13%;
 
            .react-datetime-picker {
                height: 40px !important;
                transform: translateY(-2px);

                :focus,
                :focus-within {
                    svg {
                        transform: translate(10px, 0px);
                        outline: 0 !important;
                    }
                }
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        margin-top: 0 !important;
                        padding-top: 0 !important;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        margin-top: 0 !important;
                        padding-top: 0 !important;
                    `,
                    css`
                        flex-basis: 25%;
                        max-width: 25%;
                    `,
                    css`
                        flex-basis: 25%;
                        max-width: 25%;
                    `,
                    null,
                ])}
        `,
    },
    searchSectionWrapper: {
        css: css`
            background: ${ADIColors.blue4} !important;
            height: 28px;
            display: block;
            color: ${ADIColors.white};
            font-family: Arial !important;
            font-size: 16px;
            line-height: 16px;
            font-weight: normal;
            vertical-align: middle;
            padding: 5px 1em !important;
            margin-bottom: 15px;
            clear: both;
            border-bottom: none;
        `,
    },
    footerBtnWrapper: {
        css: css`
            margin: 0px !important;
            margin-bottom: 20px !important;
            padding-top: 0px !important;
            display: flex;
            gap: 15px;
            justify-content: right;
        `,
    },
    searchBtn: {
        css: css`
            border-radius: 0px;
            width: 100px;
            min-height:28px;
            span {
                font-size: 14px;
                font-weight: bold;
            }
            :hover {
                background-color: ${getColor("primary")};
                border-color: ${getColor("primary")};
            }
        `,
    },
    clearBtn: {
        css: css`
            width: 100px;
            border-radius: 0px;
            background-color: #999999;
            border-color: unset;
            min-height:28px;
            span {
                color: #fff;
                font-size: 14px;
                font-weight: bold;
            }

            :hover {
                background-color: #999999;
                border-color: unset;
                span {
                    color: #fff;
                }
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 0;
                        margin-bottom: 0;
                        padding-bottom: 0 !important;
                    `,
                    css`
                        margin-top: 0;
                        margin-bottom: 0;
                        padding-bottom: 0 !important;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    icon: {
        css: css`
            transform: translateY(-1px) scale(0.9);
            svg {
                stroke: ${ADIColors.darkBlue1};
            }
        `,
    },
    gridItem: {
        css: css`        
            width: 100% !important;
            display: block;
            .react-datetime-picker {
                height: 40px !important;
                transform: translateY(-2px);                                
                border-radius:0px !important;  

                :focus,
                :focus-within {
                    svg {
                        transform: translate(10px, 0px);
                        outline: 0 !important;
                    }
                }
            }
        `,
    },
    dropdownLabel: {
        css: css`
            font-weight: 700;
            text-transform: capitalize;
            font-size: ${getProp("theme.typography.headerTertiary.size")};
            // margin-bottom: 7px;
            display: block;
        `,
    },
    dropdownContainer: {
        css: css`
            position: relative;
            width: 100%;
        `,
    },
    dropdownValue: {
        css: css`
            width: 100%;
            border-radius: 0px;
            padding: 9px 9px 9px 15px;
            height: 40px;
            background: ${ADIColors.white};
            border: 1px solid ${ADIColors.gray3};
            font-size: ${getProp("theme.typography.headerTertiary.size")};
            cursor: pointer;
            position: relative;
            z-index: 10;
            display: flex;
            align-items: normal;
            justify-content: space-between;
           
        `,
    },
    dropdownList: {
        css: css`
            border-radius: 0 0 7px 7px;
            box-shadow: 1px 2px 14px 4px rgba(57, 57, 58, 0.25);
            background: ${ADIColors.white1};
            position: absolute;
            width: 100%;
            top: 100%;
            transform: translateY(10px);
            z-index: 9;
              @media screen and (max-width: 1366px), screen and (max-width: 1024px), screen and (max-width: 768px), screen and (max-width: 600px) {
            width: 100%;
            z-index: 17;
            padding-bottom: 2px;
            top: 98%;
            transform: translateY(5px);
        }
        `,
    },
    dropdownValues: {
        css: css`
            min-height: 40px;
            border-bottom: 1px solid ${ADIColors.gray3};
            font-weight: 600;
            padding: 13px 12px;
            font-size: ${getProp("theme.typography.headerTertiary.size")};
            cursor: pointer;

            &:last-child {
                border-bottom: 0;
                border-radius: 0 0 7px 7px;
            }

            &.active,
            &:hover {
                background-color: ${ADIColors.blue1};
                color: ${ADIColors.white};
            }
        `,
    },
    input: {
        sizeVariant: "default",
        iconProps: {
            src: Search,
            css: css`
                padding: 6px;
                transform: rotate(90deg);
                height: 45px;
                width: 45px;
                svg {
                    height: 35px;
                    width: 35px;
                    color: ${getColor("common.background")};
                    top: -5px;
                    position: relative;
                }
            `,
        },
        border: "rounded",
        cssOverrides: {
            formField: css`
                width: 100%;                
            `,
            inputSelect: css`
                border-radius: 3px;
                font-size: 12px;
                width: 100%;
                float: right;
                height: 45px;
                padding: 0 40px 0 10px;
                font-weight: 600;
                :focus-within {
                    padding: 0 40px 0 10px;
                }
            `,
            formInputWrapper: css`
                display: flex;
                > button {
                    width: 45px !important;
                    height: 45px !important;
                    background: ${ADIColors.blue5};
                    border-radius: 0 4px 4px 0;
                    > ${IconWrapper} {
                        top: 0px;
                        right: 5px;
                        width: 40px;
                        height: 40px;
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                        css`
                            max-width: 350px;
                        `,
                    ])}
            `,
        },
    },

    Accordion: {
        css: css`
            margin-bottom: 12px;
            padding: 15px 8px 15px 15px;
            width: 100%;

            > ${AccordionSectionHeader} {
                > Button {
                    background: ${getColor("common.background")};
                    border-top-right-radius: 9px;
                    border-top-left-radius: 9px;
                }
            }
            > ${AccordionSectionPanel} {
                background: ${getColor("common.background")};
            }
        `,
    },
    mtGridItem: {
        css: css`
            flex-direction: column;
            flex-basis: 100%;
            max-width: 100%;
            margin-top: 0 !important;

            .react-datetime-picker {
                height: 40px !important;
                transform: translateY(-2px);  

                :focus,
                :focus-within {
                    svg {
                        transform: translate(10px, 0px);
                        outline: 0 !important;
                    }
                }
            }
        `,
    },
    mtGridItemDate: {
        css: css`
            flex-direction: row;
            gap: 8px;
            flex-basis: 100%;
            max-width: 100%;
            margin-top: 0 !important;
            padding-top: 2px !important;

            .react-datetime-picker {
                height: 40px !important;
                transform: translateY(-2px); 

                :focus,
                :focus-within {
                    svg {
                        transform: translate(10px, 0px);
                        outline: 0 !important;
                    }
                }
            }
        `,
    },
    toFromWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            gap: 15px;
        `,
    },
    dateWrapper: {
        css: css`
            display: flex;
            gap: 10px;
            flex-direction: row;
            width: max-content;
            align-items: center;
            .react-datetime-picker {
                height: 40px !important;
                transform: translateY(-2px);
                :focus,
                :focus-within {
                    padding: 0px 15px !important;
                    span {
                        outline: 0 !important;
                    }
                    svg {
                        /* transform: translate(10px, 0px); */
                        outline: 0 !important;
                    }
                }
            }
        `,
    },
};

const styles = ordersFilterStyles;

function useOutsideAlerter(ref: any, setaction: any) {
    React.useEffect(() => {
        function handleClickOutside(event: any) {
            if (ref.current && !ref.current.contains(event.target)) {
                setaction(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}

const tzOffset = new Date().getTimezoneOffset() * 60000;

const OrderHistoryFilter = ({
    getOrdersParameter,
    loadOrdersList,
    loadOrders,
    customerNumber,
    ordersListParameter,
    isAuthenticated,
    location,
    isLoading
}: Props) => {
    const [order, setOrder] = useState("");
    const [orderType, setOrderType] = useState("All");
    const [orderStatus, setOrderStatus] = useState("All");
    const [dateType, setDateType] = useState("30days");
    const [dateRange, setDateRange] = useState("Custom");
    const [dateRangeLabel, setDateRangeLabel] = useState("Custom");
    const [fromDate, setFromDate] = useState<Date | undefined>(undefined);
    const [toDate, setToDate] = useState<Date | undefined>(undefined);
    const [customerSequence, setcustomerSequence] = useState("-1");
    const [dayscount, setDayscount] = useState(30);
    const [initLoad, setInitLoad] = useState(true);
    const [current, setCurrent] = React.useState(0);
    const [openDates, setOpenDates] = React.useState(false);
    const [openOrderType, setOpenOrderType] = React.useState(false);
    const [openOrderStatus, setOpenOrderStatus] = React.useState(false);
    const [isMobile, setIsMobile] = React.useState(false);

    const dateRef = React.useRef(null);
    const orderStatusRef = React.useRef(null);
    const orderTypeRef = React.useRef(null);

    useOutsideAlerter(dateRef, setOpenDates);
    useOutsideAlerter(orderStatusRef, setOpenOrderStatus);
    useOutsideAlerter(orderTypeRef, setOpenOrderType);

    React.useEffect(() => {
        if (!isAuthenticated && location.pathname.includes("MyAccount")) {
            const returnUrl = location.pathname;
            window.location.href = `/MyAccount/SignIn?returnUrl=${encodeURIComponent(returnUrl)}`;
        }
    }, [isAuthenticated]);

    React.useEffect(() => {
        const onWindowResize = () => {
            setIsMobile(window.innerWidth < 700);
        };

        window.addEventListener("resize", onWindowResize);
        onWindowResize();

        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, []);

    const orderChangeHandler = (value: string) => {
        setOrder(value);
        sessionStorage.setItem("searchvalue", value);
    };

    const orderStatusChangeHandler = useCallback((value: string) => {

        setOrderStatus(value);
        setOpenOrderStatus(false);
        localStorage.setItem("selectedstatusvalue", value);
        sessionStorage.setItem("selectedstatusvalue", value);
    }, []);


    const orderTypeChangeHandler = (value: string) => {
        setOrderType(value);
        setOpenOrderType(false);
        sessionStorage.setItem("selectedtypevalue", value);
    };

    React.useEffect(() => {
        const selectedstatusvalue = sessionStorage.getItem("selectedstatusvalue");
        const selectedtypevalue = sessionStorage.getItem("selectedtypevalue");
        const searchvalue = sessionStorage.getItem("searchvalue");

        if (selectedstatusvalue !== null) {
            const statusvalu = selectedstatusvalue
                ? selectedstatusvalue === "All"
                    ? "All Orders"
                    : selectedstatusvalue === "CL"
                        ? "Closed"
                        : selectedstatusvalue === "CR"
                            ? "Credits"
                            : selectedstatusvalue === "OP"
                                ? "Open"
                                : selectedstatusvalue === "RR"
                                    ? "Returns"
                                    : selectedstatusvalue === "SH"
                                        ? "Shipped"
                                        : selectedstatusvalue
                : "";

            setOrderStatus(statusvalu);
        }
        if (selectedtypevalue !== null) {
            const statusvalutype = selectedtypevalue
                ? selectedtypevalue === "All"
                    ? "All"
                    : selectedtypevalue === "PO"
                        ? "Purchase Order Number"
                        : selectedtypevalue === "REFNUM"
                            ? "Reference Number"
                            : selectedtypevalue
                : "";

            setOrderType(statusvalutype);
        }
        if (searchvalue !== null) {
            setOrder(searchvalue);
        }
    }, []);

    const dateRangeChangeHandler = useCallback((value: string) => {
        switch (value) {
            case "2weeks": {
                setDayscount(14);
                setDateRangeLabel("Last 2 weeks");
                break;
            }
            case "30days": {
                setDayscount(30);
                setDateRangeLabel("Last 30 days");
                break;
            }
            case "60days": {
                setDayscount(60);
                setDateRangeLabel("Last 60 days");
                break;
            }
            case "90days": {
                setDayscount(90);
                setDateRangeLabel("Last 90 days");
                break;
            }
            case "custom": {
                setDayscount(30);
                setDateRangeLabel("Custom");
                break;
            }
            default: {
                setDayscount(30);
                setDateRangeLabel("Last 30 days");
                break;
            }
        }

        setDateRange(value);
        setOpenDates(false);
    }, []);

    const convertDateToString = (date?: Date) => {
        const newDate = date ? new Date(date.getTime() - tzOffset) : "";

        if (!newDate) {
            return newDate;
        }

        const month = `0${newDate.getUTCMonth() + 1}`.slice(-2);
        const day = `0${newDate.getUTCDate()}`.slice(-2);
        const year = newDate.getUTCFullYear();
        const convertedDate = `${month}/${day}/${year}`;

        return convertedDate;
    };

    const fromDateChangeHandler = ({ selectedDay }: Pick<DatePickerState, "selectedDay">) => {
        setFromDate(selectedDay);
        if (selectedDay) {
            localStorage.setItem("fromDate", selectedDay.toString());
        }
    };

    const toDateChangeHandler = ({ selectedDay }: Pick<DatePickerState, "selectedDay">) => {
        setToDate(selectedDay);
        if (selectedDay) {
            localStorage.setItem("tomDate", selectedDay.toString());
        }
    };

    useEffect(() => {
        const storedFromDate = localStorage.getItem("fromDate");
        const storedToDate = localStorage.getItem("toDate");


        if (storedFromDate) {
            setFromDate(new Date(storedFromDate));
        } else {
            let today = new Date();
            let priorDate = new Date(new Date().setDate(today.getDate() - dayscount));
            setFromDate(priorDate);
        }
        if (storedToDate) {
            setToDate(new Date(storedToDate));
        } else {
            setToDate(new Date()); // Set to today's date if no stored value
        }

    }, [])

    const getOrdersList = () => {
        const propsStatus = { status: orderStatus };
        const payload: any = {
            ...getOrdersParameter,
            status: orderStatus == "All" ? "" : orderStatus,
            properties: JSON.stringify({ 'status': orderStatus == "All" ? "" : orderStatus, 'ordersearchtype': orderType }),
            ordersearchtype: orderType,
            poNumber: order,
            isSearch: true,
            customerSequence: customerSequence,
            toDate: convertDateToString(toDate),
            fromDate: convertDateToString(fromDate),
            dateType: dateType,
            dateRange: dateRange,
            dateRangeDesc: dateRangeLabel,
            // properties: propsStatus.status === "All" ? null : JSON.stringify(propsStatus),
            sort: "OrderDate DESC",
        };
        ordersListParameter(payload);
    };

    const clearFiltersClickHandler = () => {
        let today = new Date();
        let priorDate = new Date(new Date().setDate(today.getDate() - dayscount));
        setFromDate(priorDate);
        setToDate(today);
        setOrderStatus("All");
        setOrder("");
        setDayscount(30);
        setDateRangeLabel("Last 30 Days");
        setDateRange("custom");

        loadOrdersList({
            ...getOrdersParameter,
            filter: {
                refrencenumber: "",
                ordersearchtype: "All",
                status: "All",
                toDate: convertDateToString(today),
                fromDate: convertDateToString(priorDate),
                sort: "OrderDate DESC",
                customerSequence: "-1",
                currentPage: 1,
                pageSize: 12,
                dateType: "30days",
                selectedpage: 1,
                dateRange: "Custom",
                // dateRangeDesc: "Custom",
                dateRangeDesc: "Last 30 days",
                statusDesc: "All",
                page: 1,
                poNumber: "",
                expires: "06/12/2024",
                isSearch: true,
                // properties: `{'ordersearchtype':'${orderType}','status':'${orderStatus}'}`,
                properties: `{'status':''}`,
            },
        });
    };

    // useEffect(() => {
    //     let today = new Date();
    //    // let priorDate = new Date(new Date().setDate(today.getDate() - dayscount));

    // }, [dayscount]);

    useEffect(() => {
        if (getOrdersParameter) {
            const statusValue: string | null = localStorage.getItem("selectedstatusvalue");
            const newSortOrder = getOrdersParameter.sort;
            const payload: any = {
                ...getOrdersParameter,
                status: statusValue == "" ? orderStatus : statusValue,
                properties: JSON.stringify({ 'status': statusValue == "" ? orderStatus == "All" ? "" : orderStatus : statusValue == "All" ? "" : statusValue, 'ordersearchtype': orderType, RMA: "Y" }),
                ordersearchtype: orderType,
                poNumber: order,
                isSearch: true,
                customerSequence: customerSequence,
                toDate: convertDateToString(toDate),
                fromDate: convertDateToString(fromDate),
                dateType: dateType,
                dateRange: dateRange,
                dateRangeDesc: dateRangeLabel,
                sort: newSortOrder,
            };
            loadOrdersList({
                ...getOrdersParameter,
                filter: payload
            });
        } else {
        }

    }, [getOrdersParameter]);

    const searchClickHandler = useCallback(() => {
        getOrdersList();
    }, []);

    return (
        <>
            <LoadingOverlay loading={false}>
                {isAuthenticated && (
                    <>
                        <StyledWrapper {...styles.searchSectionWrapper}>
                            <TypographyStyle>{translate("Search")}</TypographyStyle>
                        </StyledWrapper>
                        <GridContainer {...styles.filtersContainer} data-test-selector="orders_filter">
                            <GridItem width={[12, 12, 12, 3, 3]} {...styles.gridItem}>
                                <TextField
                                    {...styles.orderNumberText}
                                    value={order}
                                    label={translate("Search")}
                                    onChange={event => orderChangeHandler(event.target.value)}
                                    data-test-selector="orders_orderNumberFilter"
                                    {...styles.SearchTextFieldText}
                                />
                            </GridItem>
                            <GridItem width={[12, 12, 12, 3, 3]} {...styles.gridItem}>
                                <StyledWrapper as="label" {...styles.dropdownLabel}>
                                    {translate("Types")}
                                </StyledWrapper>
                                <StyledWrapper {...styles.dropdownContainer} ref={orderTypeRef}>
                                    <StyledWrapper {...styles.dropdownValue} onClick={() => setOpenOrderType(!openOrderType)}>

                                        {orderType
                                            ? orderType == "ALL"
                                                ? "ALL"
                                                : orderType == "PO"
                                                    ? "Purchase Order Number"
                                                    : orderType == "REFNUM"
                                                        ? "Reference Number"
                                                        : orderType
                                            : ""}
                                        <Typography {...styles.icon}>
                                            <DropDown />
                                        </Typography>
                                    </StyledWrapper>
                                    {openOrderType ? (
                                        <StyledWrapper {...styles.dropdownList} as={"ul"}>
                                            <StyledWrapper
                                                {...styles.dropdownValues}
                                                as={"li"}
                                                onClick={() => orderTypeChangeHandler("ALL")}
                                                className={orderType === "ALL" ? "active" : "normal"}
                                            >
                                                {translate("All")}
                                            </StyledWrapper>
                                            <StyledWrapper
                                                {...styles.dropdownValues}
                                                as={"li"}
                                                onClick={() => orderTypeChangeHandler("PO")}
                                                className={orderType === "PO" ? "active" : "normal"}
                                            >
                                                {translate("Purchase Order Number")}
                                            </StyledWrapper>
                                            <StyledWrapper
                                                {...styles.dropdownValues}
                                                as={"li"}
                                                onClick={() => orderTypeChangeHandler("REFNUM")}
                                                className={orderType === "REFNUM" ? "active" : "normal"}
                                            >
                                                {translate("Reference Number")}
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    ) : null}
                                </StyledWrapper>
                            </GridItem>
                            <GridItem width={[12, 12, 12, 3, 3]} {...styles.gridItem}>
                                <StyledWrapper as="label" {...styles.dropdownLabel}>
                                    {translate("Status")}
                                </StyledWrapper>
                                <StyledWrapper {...styles.dropdownContainer} ref={orderStatusRef}>
                                    <StyledWrapper {...styles.dropdownValue} onClick={() => setOpenOrderStatus(!openOrderStatus)}>
                                        {orderStatus
                                            ? orderStatus == "All"
                                                ? "All Orders"
                                                : orderStatus == "CL"
                                                    ? "Closed"
                                                    : orderStatus == "CR"
                                                        ? "Credits"
                                                        : orderStatus == "OP"
                                                            ? "Open"
                                                            : orderStatus == "RR"
                                                                ? "Returns"
                                                                : orderStatus == "SH"
                                                                    ? "Shipped "
                                                                    : orderStatus
                                            : ""}

                                        <Typography {...styles.icon}>
                                            <DropDown />
                                        </Typography>
                                    </StyledWrapper>

                                    {openOrderStatus ? (
                                        <StyledWrapper {...styles.dropdownList} as={"ul"}>
                                            <StyledWrapper
                                                {...styles.dropdownValues}
                                                as={"li"}
                                                onClick={() => orderStatusChangeHandler("All")}
                                                className={orderStatus === "All" ? "active" : "normal"}
                                            >
                                                {translate("All Orders")}
                                            </StyledWrapper>
                                            <StyledWrapper
                                                {...styles.dropdownValues}
                                                as={"li"}
                                                onClick={() => orderStatusChangeHandler("OP")}
                                                className={orderStatus === "OP" ? "active" : "normal"}
                                            >
                                                {translate("Open")}
                                            </StyledWrapper>
                                            <StyledWrapper
                                                {...styles.dropdownValues}
                                                as={"li"}
                                                onClick={() => orderStatusChangeHandler("RR")}
                                                className={orderStatus === "RR" ? "active" : "normal"}
                                            >
                                                {translate("Returns")}
                                            </StyledWrapper>
                                            <StyledWrapper
                                                {...styles.dropdownValues}
                                                as={"li"}
                                                onClick={() => orderStatusChangeHandler("SH")}
                                                className={orderStatus === "SH" ? "active" : "normal"}
                                            >
                                                {translate("Shipped")}
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    ) : null}
                                </StyledWrapper>
                            </GridItem>

                            <>

                                <GridItem width={[12, 12, 12, 3, 3]} {...styles.gridItem} data-test-selector="orders_toDateFilter">
                                    <Typography {...styles.dropdownLabel}>{translate("Date Range")}</Typography>
                                    <StyledWrapper {...styles.dateWrapper}>
                                        <Typography {...styles.dropdownLabel}>{translate("from")}</Typography>
                                        <DatePicker
                                            {...styles.datePickerFromDateStyles}
                                            selectedDay={fromDate}
                                            // label={translate("Date Range")}
                                            onDayChange={fromDateChangeHandler}
                                            format={"MM/dd/y"}
                                            dateTimePickerProps={{
                                                clearIcon: null,
                                                maxDate: toDate,
                                            }}
                                        />
                                        <Typography {...styles.dropdownLabel}>{translate("To")}</Typography>
                                        <DatePicker
                                            {...styles.datePickerToDateStyles}
                                            selectedDay={toDate}
                                            // label={translate("To")}
                                            onDayChange={toDateChangeHandler}
                                            format={"MM/dd/y"}
                                            dateTimePickerProps={{
                                                clearIcon: null,
                                                minDate: fromDate,
                                            }}
                                        />
                                    </StyledWrapper>
                                </GridItem>

                                <GridItem width={12} {...styles.footerBtnWrapper}>
                                    <Button
                                        {...styles.searchBtn}
                                        onClick={searchClickHandler}
                                        data-test-selector="orders_clearFiltersButton"
                                    >
                                        {translate("Search")}
                                    </Button>
                                    <Button
                                        {...styles.clearBtn}
                                        onClick={clearFiltersClickHandler}
                                        data-test-selector="orders_clearFiltersButton"
                                    >
                                        {translate("Clear")}
                                    </Button>
                                </GridItem>
                            </>
                        </GridContainer>
                    </>
                )}
            </LoadingOverlay>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(OrderHistoryFilter)),
    definition: {
        group: "My Account",
        displayName: "ADI Return Product Search Filter",
    },
};

export default widgetModule;